import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translocoService = inject(TranslocoService);
  const activeLang = translocoService.getActiveLang();

  req = req.clone({
    headers: req.headers.set('Accept-Language', activeLang),
  });

  return next(req);
};
